import { SVGAttributes } from "react";

export const GoogleChromeLogo2Icon = (
  props: SVGAttributes<SVGElement> & { size: "regular" }
) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5634_62)">
        <path
          d="M11.987 17.986a5.967 5.967 0 100-11.934 5.967 5.967 0 000 11.934z"
          fill="#fff"
        />
        <path
          d="M6.82 15.004l-5.167-8.95a11.93 11.93 0 0010.335 17.9l5.167-8.95v-.002a5.964 5.964 0 01-10.336.002z"
          fill="url(#paint0_linear_5634_62)"
        />
        <path
          d="M17.154 15.004l-5.166 8.949a11.925 11.925 0 0010.334-5.967 11.93 11.93 0 00-.002-11.933H11.985a5.963 5.963 0 015.97 5.967 5.962 5.962 0 01-.8 2.984z"
          fill="url(#paint1_linear_5634_62)"
        />
        <path
          d="M11.987 16.744a4.724 4.724 0 100-9.448 4.724 4.724 0 000 9.448z"
          fill="currentColor"
        />
        <path
          d="M11.987 6.053h10.334A11.928 11.928 0 0011.986.086 11.93 11.93 0 001.653 6.054l5.166 8.95h.002a5.964 5.964 0 015.166-8.95z"
          fill="url(#paint2_linear_5634_62)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5634_62"
          x1={13.279}
          y1={23.208}
          x2={2.945}
          y2={5.309}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E8E3E" />
          <stop offset={1} stopColor="#34A853" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5634_62"
          x1={10.246}
          y1={23.984}
          x2={20.58}
          y2={6.085}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCC934" />
          <stop offset={1} stopColor="#FBBC04" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5634_62"
          x1={1.653}
          y1={7.546}
          x2={22.321}
          y2={7.546}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D93025" />
          <stop offset={1} stopColor="#EA4335" />
        </linearGradient>
        <clipPath id="clip0_5634_62">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
GoogleChromeLogo2Icon.displayName = "GoogleChromeLogo2Icon";
